<div *ngIf="data" class="w-100pc">
    <div *ngIf="data?.exportFormatId === exportFormatEnum.Xero || data?.exportFormatId === exportFormatEnum.QuickBooks || data?.exportFormatId === exportFormatEnum.Netsuite || data?.exportFormatId === exportFormatEnum.DynamicsBC" class="">
        <button *ngIf="data?.successCount>0 && data?.exportFormatId === exportFormatEnum.Xero"
            class="btn eod-btn-warning btn-sm btn-block d-block mb-2" (click)="onUserAction(Xeroaction)">
            {{ "Go to Xero (Bills to Pay)" | translate: param }}
        </button>
        <button *ngIf="data?.successCount>0 && data?.exportFormatId === exportFormatEnum.QuickBooks"
            class="btn eod-btn-warning btn-sm btn-block d-block mb-2" (click)="onUserAction(Xeroaction)">
            {{ "Go to QuickBooks" | translate: param }}
        </button>
        <div class="d-flex align-items-center justify-content-center gap-8">
            <button class="btn eod-btn-primary btn-sm btn-block d-block" (click)="onUserAction(viewdetailaction)">
                {{ "view_detail" | translate: param }}
            </button>
            <button *ngIf="data?.exportFormatId === exportFormatEnum.Xero || data?.exportFormatId === exportFormatEnum.QuickBooks" type="button"
                class="btn eod-btn-outline-primary btn-sm" (click)="onDownloadAction($event)">
                <img [src]="ICONS.DOWNLOAD" alt="" class="svg-18 eod-icon-primary" />
            </button>
        </div>
    </div>
    <div *ngIf="data?.exportFormatId !== exportFormatEnum.Xero && data?.exportFormatId !== exportFormatEnum.QuickBooks && data?.exportFormatId !== exportFormatEnum.Netsuite && data?.exportFormatId !== exportFormatEnum.DynamicsBC"
        class="d-flex align-items-center justify-content-center min-w-9em">
        <button type="button" class="btn eod-btn-outline-primary btn-sm" (click)="onDownloadAction($event)">
            <img [src]="ICONS.DOWNLOAD" alt="" class="svg-18 eod-icon-primary" />
        </button>
    </div>
</div>
